import { Stethoscope } from "lucide-react";

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="min-h-screen grid lg:grid-cols-[1fr_1.1fr] bg-white">
    <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
      <div className="flex items-center gap-3 mb-12">
        <div className="h-10 w-10 rounded-xl bg-sky-600 flex items-center justify-center">
          <Stethoscope className="h-5 w-5 text-white" />
        </div>
        <span className="text-lg font-extrabold font-heading text-slate-900">MediSaaS</span>
      </div>
      <div className="w-full max-w-md animate-fade-up">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="auth-title">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-2 mb-8">{subtitle}</p>}
        {children}
      </div>
    </div>
    <div className="hidden lg:block relative overflow-hidden bg-slate-900">
      <img src="/login-hero.jpg" alt="Consultation médicale" className="absolute inset-0 h-full w-full object-cover opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/30 to-transparent" />
      <div className="absolute bottom-0 p-14 text-white max-w-xl">
        <p className="text-xs uppercase tracking-[0.2em] text-sky-300 mb-3">Plateforme multi-cabinets</p>
        <p className="text-2xl font-bold font-heading leading-snug">Chaque cabinet dans son espace isolé, avec ses modules, ses rôles et ses données.</p>
      </div>
    </div>
  </div>
);
